import React, { useEffect, useState } from "react";
import thumbPlaceholder from "../../assets/img/placeholder/video-placeholder-n.jpg";
import thumbPlaceholderBlank from "../../assets/img/placeholder/screener-thumb-placeholder.gif";
import { prepareProjectScreener } from "../../utils/api/helpers/indee";

const ScreenerGridItem = ({
  projectName,
  projectKey,
  scr,
  multiSeason,
  setOpenScreenerModal,
  setActiveScreener,
  setOverlayImage,
  setOverlayOpacity,
  setOverlayDuration,
  setOverlayPosition,
  setOverlayText,
  setOverlayInterval,
}) => {
  const [title, setTitle] = useState(null);
  const [description, setDescription] = useState(null);
  const [episodeNumber, setEpisodeNumber] = useState(null);

  const [wmImage, setWmImage] = useState("");
  const [wmOpacity, setWmOpacity] = useState(1);
  const [wmDuration, setWmDuration] = useState(0);
  const [wmPosition, setWmPosition] = useState(0);
  const [wmText, setWmText] = useState("");
  const [wmInterval, setWmInterval] = useState("");

  const [imageLoaded, setImageLoaded] = useState(false);
  const [isPreparing, setIsPreparing] = useState(false);

  useEffect(() => {
    if (!scr) return;

    setDescription(scr.description ? truncate(scr.description) : "");
    setTitle(scr.name);
    setEpisodeNumber(scr.episode);

    const owd = scr.overlay_watermark_details || {};
    setWmImage(owd.image_link || "");
    setWmOpacity(owd.opacity ?? 1);
    setWmPosition(owd.position ?? 0);
    setWmDuration(owd.duration_in_seconds ?? 0);
    setWmInterval(owd.interval_in_seconds ?? "");
    setWmText(owd.text || "");
  }, [scr]);

  const truncate = (input) => {
    if (!input) return "";
    if (input.length > 130) return input.substring(0, 130) + "...";
    return input;
  };

  const prepareScreener = async () => {
    if (isPreparing) return;

    const scrKey = scr?.key;
    if (!projectKey || !scrKey) {
      console.log("Missing projectKey or scr.key", { projectKey, scrKey });
      return;
    }

    setIsPreparing(true);
    setActiveScreener("");

    try {
      const result = await prepareProjectScreener(projectKey, scrKey);

      const newScreenerKey = result?.data?.screening_details?.screener_key;
      if (!newScreenerKey) {
        console.log("prepareProjectScreener returned no screener_key", result);
        return;
      }

      const nextScr = {
        ...scr,
        screening_details: {
          ...(scr.screening_details || {}),
          screener_key: newScreenerKey,
        },
      };

      setActiveScreener(nextScr);
      setOpenScreenerModal(true);

      setOverlayImage(wmImage);
      setOverlayOpacity(wmOpacity);
      setOverlayPosition(wmPosition);
      setOverlayDuration(wmDuration);
      setOverlayText(wmText);
      setOverlayInterval(wmInterval);
    } catch (e) {
      console.log("prepareProjectScreener error", e);
    } finally {
      setIsPreparing(false);
    }
  };

  return (
    <div
      onClick={prepareScreener}
      className={"episodegrid__item-container col-6 col-md-4 col-lg-3 mb-3"}
      style={{
        cursor: isPreparing ? "progress" : "pointer",
        opacity: isPreparing ? 0.75 : 1,
      }}
    >
      <div className="episodegrid__item-image-container">
        <img
          src={thumbPlaceholderBlank}
          alt={title || projectName}
          className={"episodegrid__item-image-placeholder"}
        />

        <img
          src={scr?.poster ? scr.poster : thumbPlaceholder}
          alt={title || projectName}
          className={`episodegrid__item-image episodegrid__item-image-placed ${
            imageLoaded ? "loaded" : ""
          }`}
          onLoad={() => setImageLoaded(true)}
        />
      </div>

      {multiSeason ? (
        <div
          style={{ fontSize: ".7rem", color: "#aaa" }}
          className={"my-2 text-uppercase fw-bold"}
        >
          Season {scr?.season}
        </div>
      ) : null}

      <div className={"episodegrid__item-title"}>
        {episodeNumber ? `${episodeNumber} - ${title}` : projectName}
      </div>

      {description && (
        <div className={"episodegrid__item-description"}>{description}</div>
      )}
    </div>
  );
};

export default ScreenerGridItem;
